import { faUser, faPerson, faPeopleGroup, faTicket } from "@fortawesome/free-solid-svg-icons";

import OverviewPhysios from "../../../components/services/physios/OverviewPhysios";
import OverviewVouchers from "../../../components/services/voucher/voucher/OverviewVouchers";
import OverviewSessionTypes from "../../../components/services/types/session/OverviewSessionTypes";
import OverviewClassTypes from "../../../components/services/types/class/OverviewClassTypes";
import ScreenWithTabs from "../../../components/general/auxiliar/ui/ScreenWithTabs";

const OverviewServices = () => {
    const tabs = [
        {
            id: "physios",
            name: "Fisioterapeutas",
            smallName: "Fisioterapeutas",
            icon: faUser,
            component: <OverviewPhysios />,
        },
        {
            id: "sessions",
            name: "Tipos de Sesión",
            smallName: "Sesiones",
            icon: faPerson,
            component: <OverviewSessionTypes />,
        },
        {
            id: "classes",
            name: "Tipos de Clase",
            smallName: "Clases",
            icon: faPeopleGroup,
            component: <OverviewClassTypes />,
        },
        {
            id: "vouchers",
            name: "Tipos de Bono",
            smallName: "Bonos",
            icon: faTicket,
            component: <OverviewVouchers />,
        },
    ];

    return <ScreenWithTabs srTitle="Servicios" tabs={tabs} />;
};

export default OverviewServices;
